/* globals console */

(function() {

    'use strict';

    window.inlineEditors = [];

    var InlineEditor = function(trigger) {

        this.input = trigger.dataset.input || 'multi';
        this.action = trigger.dataset.action;
        this.editable = trigger.dataset.editable;
        this.container = null;
        this.icon = null;
        this.active = false;

        this.attachListener(trigger);

    };

    InlineEditor.prototype.attachListener = function(trigger) {

        trigger.addEventListener('click', this.handleClick.bind(this));

    };

    InlineEditor.prototype.handleClick = function(e) {

        this.container = this.getContainerElement(e.currentTarget);
        this.icon = e.currentTarget.querySelector('i');

        if (this.active) {
            this.saveChanges();
        } else {
            this.startEditing();
        }

    };

    InlineEditor.prototype.startEditing = function() {

        this.insertInputElement(this.container);
        this.toggleEditor();

    };

    InlineEditor.prototype.insertInputElement = function(container) {

        var element;

        if(this.input === 'single') {

            element = document.createElement('input');
            element.type = 'text';

        } else {

            element = document.createElement('textarea');
            element.style.resize = 'vertical';

        }

        element.value = container.innerText;
        element.style.cssText = 'border: none; outline: none; width: 100%;background-color: rgba(0, 0, 0, 0);';

        container.innerHTML = '';
        container.appendChild(element);

        if(element instanceof HTMLTextAreaElement) {
            element.style.height = element.scrollHeight + 'px';
        }

    };

    InlineEditor.prototype.saveChanges = function() {

        var data = {};

        data[this.editable] = this.container.firstChild.value;

        window.api.patch(this.action, JSON.stringify(data)).then(function(response) {

            response.text().then(function(content) {
                this.executeResponse(content);
            }.bind(this));

        }.bind(this));

        this.toggleEditor();

    };

    InlineEditor.prototype.toggleEditor = function() {

        if(this.active) {

            this.icon.classList.remove('fa-floppy-o');
            this.icon.classList.add('fa-pencil');
            this.active = false;

        } else {

            this.icon.classList.remove('fa-pencil');
            this.icon.classList.add('fa-floppy-o');
            this.active = true;

        }

    };

    InlineEditor.prototype.getContainerElement = function(target) {

        var parent = target.closest(target.dataset.container),
            container = parent.querySelector('.editable-content');

        if(!container) {
            container = parent;
        }

        return container;

    };

    InlineEditor.prototype.executeResponse = function(content) {

        var script = document.createElement('script');
        script.text = content;

        document.head.appendChild(script).parentNode.removeChild(script);

    };

    var InlineEditors = function() {

        this.editors = [];
        this.initialize();

    };

    InlineEditors.prototype.initialize = function() {

        var buttons = document.querySelectorAll('button[data-editable]'),
            length = buttons.length;

        this.editors.length = 0;

        for(var i=0; i < length; i++) {
            this.editors.push(new InlineEditor(buttons[i]));
        }

    };

    window.inlineEditors = new InlineEditors();

})();